<template>
  <div id="simple-calendar-app">
    <!-- <div id="calendarLoadingDiv" class="vx-card vs-con-loading__container"> -->
    <div id="calendarLoadingDiv" class="vx-card no-scroll-content clubCalendarCls vs-con-loading__container">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="viewableCalendarEvents"

        :eventTop="windowWidth <= 400 ? '2rem' : '2.5rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col  w-5/12 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button class="mr-2" icon-pack="feather" icon="icon-rotate-cw" @click="refreshData()"></vs-button>
              <vs-button icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(new Date())"></vs-button>
              <vs-button class="ml-2" icon-pack="feather" icon="icon-map-pin" @click="activePromptOpenLocation = true"></vs-button>
              <vs-button class="ml-2 mr-6" icon-pack="feather" icon="icon-scissors" @click="activePromptFilterEvent = true"></vs-button>

              <!-- <vs-select placeholder="Slot Type" multiple class="selectExample" v-model="selectedClassTypes">
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in classTypesOptions" />
              </vs-select> -->
              <vs-checkbox v-for="(item,index) in classTypesOptions" v-model="selectedClassTypes" :key="index" :vs-value="item.id">{{ item.name }}</vs-checkbox>
            </div>

            <!-- Current Month -->
            <div class="vx-col w-3/12 sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col w-4/12 flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

              <vs-button  class="m-1 " @click="goToNowDate()">Now</vs-button>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                    <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                    <span>{{ label.text }}</span>
                </div>
                <div class="flex items-center mr-4 mb-2">
                  <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                  <span>Teacher Bookings</span>
                </div>
                <div class="flex items-center mr-4 mb-2">
                  <div class="h-3 w-3 inline-block rounded-full mr-2" style="background-color: #860C5A;"></div>
                  <span>Student Bookings</span>
                </div>
              </div>
            </div>
           <!--  <div class="vx-col w-1/2 flex" align="right">
              <div v-for="(item, index) in classTypesOptions" :key="index">
                  <vs-checkbox v-model="selectedClassTypes" :vs-value="item">{{ item.name }}</vs-checkbox>
              </div>
            </div> -->
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- LOCATION -->
    <vs-popup  classContent="popup-example h-full" title="Add Location" :active.sync="activePromptOpenLocation">
      <div id="createLocationLoadingDiv" class="vs-con-loading__container">
        <form data-vv-scope="addLocationForm">
          <div class="vx-row">
            <div class="vx-col w-full">
              <span>Location</span>
              <vs-input v-validate="'required|max:50'" class="w-full" name="location" ref="location" v-model="create_location" />
              <span class="text-danger text-sm" v-show="errors.has('addLocationForm.location')">{{ errors.first('addLocationForm.location') }}</span>
            </div>
          </div>

          <vs-divider></vs-divider>

          <div align="right" class="vx-row">
            <div  class="vx-col w-full mb-2">
              <vs-button v-on:click.prevent="validateAddLocationForm()" color="success" type="filled">Create Location</vs-button>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>

    <!-- FILTER -->
    <vs-popup  classContent="popup-example h-full" title="Filter" :active.sync="activePromptFilterEvent">
      <div id="createClubCalenderFilterLoadingDiv" class="vs-con-loading__container">
        <form data-vv-scope="addCalendarForm">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-radio v-model="filterType" vs-value="all">Show All</vs-radio>
            </div>
          </div>

          <vs-divider></vs-divider>

          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-radio v-model="filterType" vs-value="teacher">Teachers</vs-radio>
              <v-select v-if="filterType == 'teacher'" label="title" v-validate="'required'" name="teacher" ref="teacher" v-model="filterTypeTeacher" :options="teachersData"/>
            </div>
          </div>

          <vs-divider></vs-divider>

          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-radio v-model="filterType" vs-value="class">Classes</vs-radio>
              <v-select v-if="filterType == 'class'"  v-validate="'required'" name="teacher" ref="teacher" v-model="filterTypeClass" :options="clubModulesData"/>
            </div>
          </div>

          <vs-divider></vs-divider>

          <div class="vx-row">
            <div class="vx-col w-full mb-6">
              <vs-radio v-model="filterType" vs-value="location">Location</vs-radio>
              <v-select v-if="filterType == 'location'" v-validate="'required'" name="teacher" ref="teacher" v-model="filterTypeLocation" :options="clubLocationsData"/>
            </div>
          </div>

          <div align="right" class="vx-row">
            <div  class="vx-col w-full mb-2">
              <vs-button :disabled="filterDataButtonStatus" v-on:click.prevent="FilterData()" color="success" type="filled">Filter</vs-button>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>

    <!-- ADD CALENDAR CLASS -->
    <vs-popup fullscreen  classContent="popup-example h-full" title="Create Calendar" :active.sync="activePromptAddEvent">
      <div id="createClubCalenderLoadingDiv" class="vs-con-loading__container">
        <form data-vv-scope="addCalendarForm">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-6">
              <span>Module</span>
              <v-select @input="changeModule" v-validate="'required'" name="clubModules" ref="clubModules" v-model="createClubCalender.clubModules" :options="clubModulesData" />
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.clubModules')">{{ errors.first('addCalendarForm.clubModules') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-6">
              <span>Location</span>
              <v-select v-validate="'required'" name="class_location" ref="class_location" v-model="createClubCalender.class_location" :options="locationsData" />
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.class_location')">{{ errors.first('addCalendarForm.class_location') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-6">
              <span>Start Time</span>
              <v-select @input="changeStartTime" v-validate="'required'" name="time_from" ref="time_from" v-model="createClubCalender.time_from" :options="timesArrayData"/>
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.time_from')">{{ errors.first('addCalendarForm.time_from') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-6">
              <span>Number of students</span>
              <vs-input v-validate="'required|numeric|min_value:1'" class="w-full" name="number_of_students" ref="number_of_students" v-model="createClubCalender.number_of_students" />
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.number_of_students')">{{ errors.first('addCalendarForm.number_of_students') }}</span>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-4">
              <span>Teacher Type</span>
              <v-select v-model="createClubCalender.teacherType" :options="teacherTypeOptions"/><br>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-4" v-if="createClubCalender.teacherType.id == 1 || createClubCalender.teacherType.id == 2">
              <span>Teacher Name</span>
              <v-select label="title" v-validate="'required'" v-if="createClubCalender.teacherType.id == 1" name="teacher" ref="teacher" v-model="createClubCalender.internalTeacher" :options="internalTachersData"/>
              <span v-if="createClubCalender.teacherType.id == 1" class="text-danger text-sm" v-show="errors.has('addCalendarForm.teacher')">{{ errors.first('addCalendarForm.teacher') }}</span>

              <v-select label="title" v-if="createClubCalender.teacherType.id == 2" v-validate="'required'" name="teacher" ref="teacher" v-model="createClubCalender.externalTeacher" :options="externalTachersData" />
              <span v-if="createClubCalender.teacherType.id == 2" class="text-danger text-sm" v-show="errors.has('addCalendarForm.teacher')">{{ errors.first('addCalendarForm.teacher') }}</span>
            </div>
            <div v-else class="vx-col sm:w-1/4 w-full mb-4"></div>
            <div  class="vx-col sm:w-1/4 w-full mb-4">
              <span>Stop Time</span>
              <vs-input class="w-full" readonly="true" v-model="createClubCalender.time_to" />
            </div>

          </div>

          <div class="vx-row">
            <div v-if="createClubCalender.teacherType.id == 3" class="vx-col sm:w-1/4 w-full mb-4">
              <span>Teacher Name</span>
              <vs-input  v-validate="'required'" class="w-full"  name="teacher_name" ref="teacher_name" v-model="createClubCalender.externalTeacher.name" />
              <span v-if="createClubCalender.teacherType.id == 3" class="text-danger text-sm" v-show="errors.has('addCalendarForm.teacher_name')">{{ errors.first('addCalendarForm.teacher_name') }}</span>
            </div>
            <div v-if="createClubCalender.teacherType.id == 3" class="vx-col sm:w-1/4 w-full mb-4">
              <span>Teacher Email</span>
              <vs-input class="w-full"  v-validate="'required|email'" name="teacher_email" ref="teacher_email" v-model="createClubCalender.externalTeacher.email" />
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.teacher_email')">{{ errors.first('addCalendarForm.teacher_email') }}</span>
            </div>
            <div v-if="createClubCalender.teacherType.id == 3" class="vx-col sm:w-1/4 w-full mb-4">
              <span>Teacher Phone</span>
              <vs-input class="w-full"  v-validate="'required|numeric|digits:8'" name="teacher_phone" ref="teacher_phone" v-model="createClubCalender.externalTeacher.phone" />
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.teacher_phone')">{{ errors.first('addCalendarForm.teacher_phone') }}</span>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-7/12">
              <span>Class in</span>
              <ul class="demo-alignment">
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="createClubCalender.day" vs-value="MON">Monday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="createClubCalender.day" vs-value="TUE">Tuesday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="createClubCalender.day" vs-value="WED">Wedsnday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="createClubCalender.day" vs-value="THU">Thursday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="createClubCalender.day" vs-value="FRI">Friday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="createClubCalender.day" vs-value="SAT">Satruday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="createClubCalender.day" vs-value="SUN">Sunday</vs-checkbox></li>
              </ul>
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.day')">{{ errors.first('addCalendarForm.day') }}</span>
            </div>
            <div class="vx-col w-5/12">
              <span>Repeat for</span>
              <ul class="demo-alignment">
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="createClubCalender.repeat_for" vs-value="1">1st week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="createClubCalender.repeat_for" vs-value="2">2nd week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="createClubCalender.repeat_for" vs-value="3">3rd week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="createClubCalender.repeat_for" vs-value="4">4th week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="createClubCalender.repeat_for" vs-value="5">5th week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="createClubCalender.repeat_for" vs-value="6">6th week</vs-checkbox></li>
              </ul>
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.repeat_for')">{{ errors.first('addCalendarForm.repeat_for') }}</span>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <small class="date-label">Start Date</small>
              <datepicker v-validate="'required'" name="date_from" ref="date_from" format="dd-MM-yyyy" :disabledDates="disabledDatesTo" v-model="createClubCalender.date_from" ></datepicker>
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.date_from')">{{ errors.first('addCalendarForm.date_from') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <small class="date-label">End Date</small>
              <datepicker v-validate="'required'" name="date_to" ref="date_to" format="dd-MM-yyyy" :disabledDates="disabledDatesTo" v-model="createClubCalender.date_to"></datepicker>
              <span class="text-danger text-sm" v-show="errors.has('addCalendarForm.date_to')">{{ errors.first('addCalendarForm.date_to') }}</span>
            </div>
          </div>

          <div align="right" class="vx-row">
            <div  class="vx-col w-full mb-2">
              <vs-button v-on:click.prevent="validateAddCalendarForm()" color="success" type="filled">Create Calendar</vs-button>
            </div>
          </div>
        </form>
      </div>

      <vs-popup  classContent="popup-example h-full" title="Confirm" :active.sync="activePromptOpenConfirm">
        <div id="createCalConformLoadingDiv" class="vs-con-loading__container">
          <form data-vv-scope="addLocationForm">
            <div class="vx-row">
              <div class="vx-col w-full">
                <span>Are you confirm to create this class ?</span>
              </div>
            </div>

            <div align="right" class="vx-row">
              <div  class="vx-col w-full mb-2">
                <vs-button v-on:click.prevent="createNewClubCalender()" color="success" type="filled">Confirm</vs-button>
              </div>
            </div>
          </form>
        </div>
      </vs-popup>

    </vs-popup>

    <!-- EDIT CALENDAR CLASS -->
    <vs-popup fullscreen classContent="popup-example h-full" title="Class Details" :active.sync="activePromptEditEvent">
      <div id="editClubCalenderLoadingDiv" class="vs-con-loading__container">
        <form data-vv-scope="editCalendarForm">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-6">
              <span>Module</span>
              <v-select @input="changeModuleEdit" v-validate="'required'" name="clubModules" ref="clubModules" v-model="editClubCalender.clubModules" :options="clubModulesData" />
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.clubModules')">{{ errors.first('editCalendarForm.clubModules') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-6">
              <span>Location</span>
              <v-select v-validate="'required'" name="class_location" ref="class_location" v-model="editClubCalender.class_location" :options="locationsData" />
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.class_location')">{{ errors.first('editCalendarForm.class_location') }}</span>
            </div>

             <div class="vx-col sm:w-1/4 w-full mb-6">
              <span>Start Time</span>
              <v-select @input="changeStartTimeEdit" v-validate="'required'" name="time_from" ref="time_from" v-model="editClubCalender.time_from" :options="timesArrayData"/>
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.time_from')">{{ errors.first('editCalendarForm.time_from') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-6">
              <span>Number of students</span>
              <vs-input v-validate="'required|numeric|min_value:1'" class="w-full" name="number_of_students" ref="number_of_students" v-model="editClubCalender.number_of_students" />
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.number_of_students')">{{ errors.first('editCalendarForm.number_of_students') }}</span>
            </div>
          </div>

  
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-4">
              <span>Teacher Type</span>
              <v-select v-model="editClubCalender.teacherType" :options="teacherTypeOptions"/><br>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-4"  v-if="editClubCalender.teacherType.id == 1 || editClubCalender.teacherType.id == 2" >
              <span>Teacher Name</span>
              <v-select label="title" v-validate="'required'" v-if="editClubCalender.teacherType.id == 1" name="teacher" ref="teacher" v-model="editClubCalender.internalTeacher" :options="internalTachersData"/>
              <span v-if="editClubCalender.teacherType.id == 1" class="text-danger text-sm" v-show="errors.has('editCalendarForm.teacher')">{{ errors.first('editCalendarForm.teacher') }}</span>

              <v-select label="title" v-if="editClubCalender.teacherType.id == 2" v-validate="'required'" name="teacher" ref="teacher" v-model="editClubCalender.externalTeacher" :options="externalTachersData" />
              <span v-if="editClubCalender.teacherType.id == 2" class="text-danger text-sm" v-show="errors.has('editCalendarForm.teacher')">{{ errors.first('editCalendarForm.teacher') }}</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-4">
              <span>Stop Time</span>
              <vs-input class="w-full" readonly="true" v-model="editClubCalender.time_to" />
            </div>
          </div>

          <div class="vx-row">
            <div v-if="editClubCalender.teacherType.id == 3" class="vx-col sm:w-1/4 w-full mb-4">
              <span>Teacher Name</span>
              <vs-input v-if="editClubCalender.teacherType.id == 3" v-validate="'required'" class="w-full"  name="teacher_name" ref="teacher_name" v-model="editClubCalender.externalTeacher.name" />
              <span v-if="editClubCalender.teacherType.id == 3" class="text-danger text-sm" v-show="errors.has('editCalendarForm.teacher_name')">{{ errors.first('editCalendarForm.teacher_name') }}</span>
            </div>
            <div v-if="editClubCalender.teacherType.id == 3" class="vx-col sm:w-1/4 w-full mb-4">
              <span>Teacher Email</span>
              <vs-input class="w-full"  v-validate="'required|email'" name="teacher_email" ref="teacher_email" v-model="editClubCalender.externalTeacher.email" />
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.teacher_email')">{{ errors.first('editCalendarForm.teacher_email') }}</span>
            </div>
            <div v-if="editClubCalender.teacherType.id == 3" class="vx-col sm:w-1/4 w-full mb-4">
              <span>Teacher Phone</span>
              <vs-input class="w-full"  v-validate="'required|numeric|digits:8'" name="teacher_phone" ref="teacher_phone" v-model="editClubCalender.externalTeacher.phone" />
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.teacher_phone')">{{ errors.first('editCalendarForm.teacher_phone') }}</span>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-7/12 mb-1">
              <span>Class in</span>
              <ul class="demo-alignment">
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="editClubCalender.day" vs-value="MON">Monday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="editClubCalender.day" vs-value="TUE">Tuesday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="editClubCalender.day" vs-value="WED">Wedsnday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="editClubCalender.day" vs-value="THU">Thursday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="editClubCalender.day" vs-value="FRI">Friday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="editClubCalender.day" vs-value="SAT">Satruday</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="day" ref="day" v-model="editClubCalender.day" vs-value="SUN">Sunday</vs-checkbox></li>
              </ul>
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.day')">{{ errors.first('editCalendarForm.day') }}</span>
            </div>
            <div class="vx-col w-5/12">
              <span>Repeat for</span>
              <ul class="demo-alignment">
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="editClubCalender.repeat_for" vs-value="1">1st week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="editClubCalender.repeat_for" vs-value="2">2nd week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="editClubCalender.repeat_for" vs-value="3">3rd week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="editClubCalender.repeat_for" vs-value="4">4th week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="editClubCalender.repeat_for" vs-value="5">5th week</vs-checkbox></li>
                <li><vs-checkbox v-validate="''" name="repeat_for" ref="repeat_for" v-model="editClubCalender.repeat_for" vs-value="6">6th week</vs-checkbox></li>
              </ul>
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.repeat_for')">{{ errors.first('editCalendarForm.repeat_for') }}</span>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <small class="date-label">Start Date</small>
              <datepicker v-validate="'required'" name="date_from" ref="date_from" format="dd-MM-yyyy" :disabledDates="disabledDatesTo" v-model="editClubCalender.date_from" ></datepicker>
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.date_from')">{{ errors.first('editCalendarForm.date_from') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <small class="date-label">End Date</small>
              <datepicker v-validate="'required'" name="date_to" ref="date_to" format="dd-MM-yyyy" :disabledDates="disabledDatesTo" v-model="editClubCalender.date_to"></datepicker>
              <span class="text-danger text-sm" v-show="errors.has('editCalendarForm.date_to')">{{ errors.first('editCalendarForm.date_to') }}</span>
            </div>
          </div>

          <div align="right" class="vx-row">
            <div  class="vx-col w-full">
              <vs-button v-if="editClubCalenderData && editClubCalenderData.date" v-on:click.prevent="cancelSelectedDateClasses()" class="mr-2" color="danger" type="filled">Cancel classes on {{stringToDate(editClubCalenderData.date)}}</vs-button>
              <vs-button v-on:click.prevent="cancelSingleClubCalender()" class="mr-2" color="danger" type="filled">Cancel all classes</vs-button>
              <vs-button v-on:click.prevent="validateEditCalendarForm()" color="success" type="filled">Update Class</vs-button>
            </div>
          </div>

          <vs-divider/>

          <div class="vx-row ml-4" v-if="studentBooking.length || teacherClubBookings.length">
<!--             <div  class="vx-col w-1/2">
              <vs-list>
                <vs-list-header title="Teacher bookings" color="primary"></vs-list-header>
                <vs-list-item :title="stringToDate(singleTeacherClubBooking.date)" :subtitle="singleTeacherClubBooking.time_from+' - '+singleTeacherClubBooking.time_to" v-for="(singleTeacherClubBooking, index) in teacherClubBookings">
                  <div class="vx-row" v-if="singleTeacherClubBooking.status == 'P'">
                    <vs-button size="small" v-on:click.prevent="addStudentBooking(singleTeacherClubBooking)" color="primary" class="mr-2" type="border" icon-pack="feather" icon="icon-plus-circle">Book class</vs-button>
                    <vs-button size="small" v-on:click.prevent="cancelTeacherBooking(singleTeacherClubBooking)"  color="danger" type="filled" icon-pack="feather" icon="icon-trash">Cancel class</vs-button>
                  </div>
                  <div class="vx-row" v-else>
                    <vs-button size="small"  color="danger" type="filled" icon-pack="feather" icon="icon-trash">Cancelled</vs-button>
                  </div>
                </vs-list-item>
              </vs-list>
            </div> -->

            <div  class="vx-col w-1/2">
              <vs-list>
                <vs-list-header title="Students bookings" color="primary"></vs-list-header>
                <vs-list-item :title="singleStudentBooking.student.name+' '+singleStudentBooking.student.last_name" v-for="(singleStudentBooking, index) in studentBooking">
                  <vs-chip class="ag-grid-cell-chip mt-6" color="danger" v-if="singleStudentBooking.attendance == 'Cancelled'">
                    <span>Cancelled</span>
                  </vs-chip>
                  <template slot="avatar">
                    <vs-avatar :src="'https://backend.tittam.com/public/images/users/'+singleStudentBooking.student.image" />
                  </template>
                </vs-list-item>
              </vs-list>
            </div>
          </div>
        </form>
      </div>

      <!-- Select CLASS and student for booking -->
      <vs-popup  classContent="popup-example h-full" title="Select student to book class" :active.sync="activePromptAddStudentBooking">
        <div id="createClubCalenderStudentLoadingDiv" class="vs-con-loading__container">
          <form data-vv-scope="bookStudentBookingForm">
            <div class="vx-row" v-if="!selectedStudentModule">
              <div class="vx-col w-full mb-6">
                <span>Select Module</span>
                <v-select v-validate="'required'" name="module" ref="module" v-model="bookStudentBooking.module" :options="teacherModulesData" />
                <span class="text-danger text-sm" v-show="errors.has('bookStudentBookingForm.module')">{{ errors.first('bookStudentBookingForm.module') }}</span>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full mb-4">
                <span>Select Student</span>
                <v-select v-model="bookStudentBooking.student" name="student" ref="student" v-validate="'required'" @search="fetchOptions" :options="studentsLists" >
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      <!-- <vs-avatar size="25px" :src="option.student.image_full_path" /> -->
                      <img width="20" :src='option.student.image_full_path'/>
                      {{ option.student.name }} {{ option.student.last_name }}
                      </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      <!-- <vs-avatar size="25px" :src="option.student.image_full_path" /> -->
                      <img width="20" :src='option.student.image_full_path'/>
                      {{ option.student.name }} {{ option.student.last_name }}
                    </div>
                  </template>
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('bookStudentBookingForm.student')">{{ errors.first('bookStudentBookingForm.student') }}</span>
              </div>
            </div>

            <div align="right" class="vx-row">
              <div  class="vx-col w-full mb-2">
                <vs-button v-on:click.prevent="validateBookStudent()" color="success" type="filled">Create Calendar</vs-button>
              </div>
            </div>
          </form>
        </div>
      </vs-popup>

      <vs-popup  classContent="popup-example h-full" title="Confirm" :active.sync="activePromptOpenConfirmEdit">
        <div id="createCalConformLoadingDiv" class="vs-con-loading__container">
          <form data-vv-scope="addLocationForm">
            <div class="vx-row">
              <div class="vx-col w-full">
                <span>Are you confirm to create this class ?</span>
              </div>
            </div>

            <div align="right" class="vx-row">
              <div  class="vx-col w-full mb-2">
                <vs-button v-on:click.prevent="editSingleClubCalender()" color="success" type="filled">Confirm</vs-button>
              </div>
            </div>
          </form>
        </div>
      </vs-popup>

    </vs-popup>

    <!-- EDIT TEACHER CLASS -->
    <vs-popup classContent="popup-example h-full" title="Class Details" :active.sync="activePromptEditTeacherEvent">
      <div id="editTeacherCalenderLoadingDiv" class="vs-con-loading__container">
        <div class="vx-row" v-if="teacherClassStudentBookings.length">
          <div  class="vx-col w-full">

            <vs-list>
              <vs-list-header title="Students bookings" color="primary"></vs-list-header>
              <vs-list-item :title="singleStudentBooking.users.name+' '+singleStudentBooking.users.last_name" :subtitle="singleStudentBooking.time" v-for="(singleStudentBooking, index) in teacherClassStudentBookings">
                <vs-chip class="ag-grid-cell-chip mt-6" color="danger" v-if="singleStudentBooking.attendance == 'Cancelled'">
                  <span>Cancelled</span>
                </vs-chip>
                <template slot="avatar">
                  <vs-avatar :src="singleStudentBooking.users.image_path" />
                </template>
              </vs-list-item>
            </vs-list>
          </div>
        </div>

        <div class="vx-row" v-else>
          <div  class="vx-col w-full" style="min-width: 150px;">
            <vs-alert color="danger" title="No class" active="true" class="mt-3" style="min-width: 100px;">
              No bookings found yet
            </vs-alert>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import { en, he } from "vuejs-datepicker/src/locale"
require("vue-simple-calendar/static/css/default.css")
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import moduleCalendarManagement from '@/store/calendar-management/moduleCalendarManagement.js'
import moduleModuleManagement from '@/store/module-management/moduleModuleManagement.js'

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    'v-select': vSelect,
  },
  data() {
    return {
      selectedClassTypes: [
        1
      ],
      classTypesOptions: [
        { id: 1, name: 'Club' },
        { id: 2, name: 'Teacher' },
        { id: 3, name: 'Student' },
      ],
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',
      langHe: he,
      langEn: en,
      url: '',
      calendarView: 'month',
      create_location: null,
      activePromptOpenLocation: false,
      activePromptAddEvent: false,
      activePromptEditEvent: false,
      activePromptAddStudentBooking: false,
      selectedTeacherBookingClubClass : null,
      selectedStudentModule : null,
      studentsLists : [],
      teacherClassStudentBookings : [],
      bookStudentBooking : {
        student : null,
        module : null,
      },
      calendarViewTypes: [
        {
          label: "Month",
          val: "month"
        },
        {
          label: "Week",
          val: "week"
        },
        {
          label: "Year",
          val: "year"
        },
      ],
      classTypes: [
        {
          color: "success",
          text: "Teori",
          value: "teori"
        },
        {
          color: "warning",
          text: "Manøvre",
          value: "manøvre"
        },
        {
          color: "danger",
          text: "Glatbane",
          value: "glatbane"
        },
      ],
      options: [
        {id: 1, label: 'foo'},
        {id: 3, label: 'bar'},
        {id: 2, label: 'baz'},
      ],
      timesArrayData : [{
          id: "00:00",
          label: "00:00"
        }, {
          id: "00:30",
          label: "00:30"
        }, {
          id: "01:00",
          label: "01:00"
        }, {
          id: "01:30",
          label: "01:30"
        }, {
          id: "02:00",
          label: "02:00"
        }, {
          id: "02:30",
          label: "02:30"
        }, {
          id: "03:00",
          label: "03:00"
        }, {
          id: "03:30",
          label: "03:30"
        }, {
          id: "04:00",
          label: "04:00"
        }, {
          id: "04:30",
          label: "04:30"
        }, {
          id: "05:00",
          label: "05:00"
        }, {
          id: "05:30",
          label: "05:30"
        }, {
          id: "06:00",
          label: "06:00"
        }, {
          id: "06:30",
          label: "06:30"
        }, {
          id: "07:00",
          label: "07:00"
        }, {
          id: "07:30",
          label: "07:30"
        }, {
          id: "08:00",
          label: "08:00"
        }, {
          id: "08:30",
          label: "08:30"
        }, {
          id: "09:00",
          label: "09:00"
        }, {
          id: "09:30",
          label: "09:30"
        }, {
          id: "10:00",
          label: "10:00"
        }, {
          id: "10:30",
          label: "10:30"
        }, {
          id: "11:00",
          label: "11:00"
        }, {
          id: "11:30",
          label: "11:30"
        }, {
          id: "12:00",
          label:  "12:00",
        }, {
          id: "12:30",
          label: "12:30",
        }, {
          id: "13:00",
          label: "13:00",
        }, {
          id: "13:30",
          label: "13:30",
        }, {
          id: "14:00",
          label: "14:00",
        }, {
          id: "14:30",
          label: "14:30",
        }, {
          id: "15:00",
          label:"15:00",
        }, {
          id: "15:30",
          label: "15:30",
        }, {
          id: "16:00",
          label: "16:00",
        }, {
          id: "16:30",
          label: "16:30",
        }, {
          id: "17:00",
          label:  "17:00",
        }, {
          id: "17:30",
          label:  "17:30",
        }, {
          id: "18:00",
          label: "18:00",
        }, {
          id: "18:30",
          label:  "18:30",
        }, {
          id: "19:00",
          label: "19:00",
        }, {
          id: "19:30",
          label: "19:30",
        }, {
          id: "20:00",
          label: "20:00",
        }, {
          id: "20:30",
          label: "20:30",
        }, {
          id: "21:00",
          label: "21:00",
        }, {
          id: "21:30",
          label: "21:30",
        }, {
          id: "22:00",
          label:  "22:00",
        }, {
          id: "22:30",
          label: "22:30",
        }, {
          id: "23:00",
          label: "23:00",
        }, {
          id: "23:30",
          label: "23:30",
        }
      ],
      createClubCalender : {
        class_location : null,
        number_of_students : 1,
        day : [],
        repeat_for : [],
        time_from : null,
        time_to : null,
        internalTeacher : null,
        externalTeacher : {
          name : "",
          email : "",
          phone : "",
        },
        clubModules : null,
        date_from : '',
        date_to : '',
        teacherType: {id: 1, label: 'Internal teacher'},
      },
      editClubCalenderData : null,
      editClubCalender : {
        class_location : null,
        number_of_students : 1,
        day : [],
        repeat_for : [],
        time_from : null,
        time_to : null,
        internalTeacher : null,
        externalTeacher : {
          name : "",
          email : "",
          phone : "",
        },
        clubModules : null,
        date_from : '',
        date_to : '',
        teacherType: {id: 1, label: 'Internal teacher'},
      },
      teacherTypeOptions: [
        {id: 1, label: 'Internal teacher'},
        {id: 2, label: 'External teacher'},
        {id: 3, label: 'Add new External teacher '},
      ],
      selected: {id: 3, label: 'bar'},
      checkBox1: ['luis'],
      activePromptOpenConfirmEdit: false,
      activePromptOpenConfirm: false,
      activePromptFilterEvent: false,
      filterType: "all",
      filterTypeClass: null,
      filterTypeTeacher: null,
      filterTypeLocation: null,
      simpleCalendarEvents : [],
      studentBooking : [],
      teacherClubBookings : [],
      activePromptEditTeacherEvent : false,
    }
  },
  computed: {
    filterDataButtonStatus() {
      if(this.filterType == "all") return false
      else if(this.filterType == "teacher"){
        return (this.filterTypeTeacher) ? false : true
      }
      else if(this.filterType == "class"){
        return (this.filterTypeClass) ? false : true
      }
      else if(this.filterType == "location"){
        return (this.filterTypeLocation) ? false : true
      }
    },
    teachersData() {
      let teachers = this.$store.state.userManagement.teachers
      let teachersData = []

      teachers.forEach(function(entry, key) {
        teachersData.push({
          id : entry.id,
          image : entry.image,
          title : entry.name+" "+entry.last_name,
        })
      });

      return teachersData
    },
    internalTachersData() {
      let teachers = this.$store.state.userManagement.internalTeachers
      let teachersData = []

      teachers.forEach(function(entry, key) {
        teachersData.push({
          id : entry.id,
          image : entry.image,
          title : entry.name+" "+entry.last_name,
        })
      });

      return teachersData
    },
    externalTachersData() {
      let teachers = this.$store.state.userManagement.externalTeachers
      let teachersData = []

      teachers.forEach(function(entry, key) {
        teachersData.push({
          id : entry.id,
          image : entry.image,
          title : entry.name+" "+entry.last_name,
        })
      });

      return teachersData
    },
    clubLocationsData() {
      return this.$store.state.calendarManagement.clubLocations
    },
    clubModulesData() {
      let clubModules =this.$store.state.calendarManagement.clubModules
      let clubModulesData = []

      clubModules.forEach(function(entry, key) {
        clubModulesData.push({
          id : entry.id,
          label : entry.name,
        })
      });

      return clubModulesData
    },
    locationsData() {
      let clubLocations = this.$store.state.calendarManagement.clubLocations
      let clubLocationsData = []

      clubLocations.forEach(function(entry, key) {
        clubLocationsData.push({
          id : entry.id,
          label : entry.location,
        })
      });

      return clubLocationsData
    },
    teacherModulesData() {
      let clubModulesData = []
      let clubModules =this.$store.state.moduleManagement.modules

      clubModules.forEach(function(entry, key) {
        if(entry.type == "kørsel"){
          clubModulesData.push({
            id : entry.id,
            label : entry.name,
          })
        }
      });

      return clubModulesData
    },
    // simpleCalendarEvents() {
    //   return this.$store.state.calendarManagement.clubClasses
    // },
    viewableCalendarEvents() {
      if(this.selectedClassTypes.length){
        var finalCalendarEvents = [];
        let calendarEvents = this.simpleCalendarEvents
        for(var i = 0; i < this.selectedClassTypes.length; i++){

          if(this.selectedClassTypes[i] == 1){
            var clubCalendarEvents = calendarEvents.filter(obj => { return obj.view_calendar_type == "club_class"})
            Array.prototype.push.apply(finalCalendarEvents,clubCalendarEvents); 
          }
          else if(this.selectedClassTypes[i] == 2){
            var teacherCalendarEvents = calendarEvents.filter(obj => { return obj.view_calendar_type == "teacher_class"})
            Array.prototype.push.apply(finalCalendarEvents,teacherCalendarEvents); 
          }
          else if(this.selectedClassTypes[i] == 3){
            var studentCalendarEvents = calendarEvents.filter(obj => { return obj.view_calendar_type == "student_class"})
            Array.prototype.push.apply(finalCalendarEvents,studentCalendarEvents); 
          }
        }

        return finalCalendarEvents;
      }
      else return [];
    },
    validForm() {
      return this.title != '' && this.startDate != '' && this.endDate != '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
    },
    disabledDatesTo() {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom() {
      return { from: new Date(this.endDate) }
    },
    calendarLabels() {
      return this.classTypes
    },
    labelColor() {
      return (label) => {
        if (label == "teori") return "success"
        else if (label == "manøvre") return "warning"
        if (label == "glatbane") return "danger"
        if (label == "none") return "primary"
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    stringToDate(string){
      const date = new Date(string);
      const yyyy = date.getFullYear();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      return dd + '-' + mm + '-' + yyyy;
    },
    goToNowDate(){
      this.showDate = new Date();
    },
    async cancelSelectedDateClasses(){
      var self = this
      this.$vs.loading({
        container: '#editClubCalenderLoadingDiv',
        scale: 0.6
      })

      await this.$store.dispatch("calendarManagement/cancelMultipleTeacherCalender", { club_calendar_id : [this.editClubCalenderData.id]})
        .then(res => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
          this.activePromptEditEvent = false;
          this.$vs.notify({
            title: "Success.",
            text: "Class cancelled successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
        })

      await this.$store.dispatch("calendarManagement/fetchClubClasses")
        .then(res => { 
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 
          this.simpleCalendarEvents = [];
        })

      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
        .then(res => { 
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 

        })
    },
    changeModule(){
      if(this.createClubCalender.clubModules && this.createClubCalender.clubModules.id){
        let modulesArray = this.$store.state.moduleManagement.modules
        let findModule = modulesArray.find(o => o.id === this.createClubCalender.clubModules.id);

        if(findModule){
          this.createClubCalender.number_of_students = findModule.number_of_students ? findModule.number_of_students : 10;
        }

        this.changeStartTime()
      }
    },
    changeModuleEdit(){
      if(this.editClubCalender.clubModules && this.editClubCalender.clubModules.id){
        let modulesArray = this.$store.state.moduleManagement.modules
        let findModule = modulesArray.find(o => o.id === this.editClubCalender.clubModules.id);

        if(findModule){
          this.editClubCalender.number_of_students = findModule.number_of_students ? findModule.number_of_students : 10;
        }

        this.changeStartTimeEdit()
      }
    },
    addMinutes(time, minsToAdd) {
      function D(J){ return (J<10? '0':'') + J;};
      var piece = time.split(':');
      var mins = piece[0]*60 + +piece[1] + +minsToAdd;

      return D(mins%(24*60)/60 | 0) + ':' + D(mins%60);  
    },
    changeStartTime(){
      if(this.createClubCalender.clubModules && this.createClubCalender.clubModules.id){
        let modulesArray = this.$store.state.moduleManagement.modules
        let findModule = modulesArray.find(o => o.id === this.createClubCalender.clubModules.id);

        if(findModule && this.createClubCalender.time_from){
          this.createClubCalender.time_to = this.addMinutes(this.createClubCalender.time_from.id+":00", findModule.hours)+" ("+findModule.hours+" Min)"
        }
      }
    },
    changeStartTimeEdit(){
      if(this.editClubCalender.clubModules && this.editClubCalender.clubModules.id){
        let modulesArray = this.$store.state.moduleManagement.modules
        let findModule = modulesArray.find(o => o.id === this.editClubCalender.clubModules.id);

        if(findModule && this.editClubCalender.time_from){
          this.editClubCalender.time_to = this.addMinutes(this.editClubCalender.time_from.id+":00", findModule.hours)+" ("+findModule.hours+" Min)"
        }
      }
    },
    async fetchOptions (search, loading) {
      loading(true);
      if(search.length > 2){
        await this.$store.dispatch("calendarManagement/searchStudents", { student_name : search})
          .then(res => { 
            this.studentsLists = res.data;
            loading(false);
            console.log(res)
          })
          .catch(err => { 
            loading(false);
          })
      }

      loading(false);
    },
    addStudentBooking(teacherBooking){
      this.selectedStudentModule = (teacherBooking.module_id) ? teacherBooking.module_id : null;
      this.studentsLists = [];
      this.selectedTeacherBookingClubClass = teacherBooking;
      this.activePromptAddStudentBooking = true;
    },
    async cancelTeacherBooking(teacherBooking){
      var self = this
      this.$vs.loading({
        container: '#editClubCalenderLoadingDiv',
        scale: 0.6
      })

      await this.$store.dispatch("calendarManagement/cancelTeacherCalender", { teacher_booking_id : teacherBooking.id})
        .then(res => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
          this.activePromptEditEvent = false;
          this.$vs.notify({
            title: "Success.",
            text: "Class cancelled successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
        })

      await this.$store.dispatch("calendarManagement/fetchClubClasses")
        .then(res => { 
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 
          this.simpleCalendarEvents = [];
        })

      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
        .then(res => { 
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 

        })
    },
    validateBookStudent() {
      this.$validator.validateAll('bookStudentBookingForm').then(result => {
        if (result) this.bookStudentClubClass();
        else console.log(this.errors)
      })
    },
    async bookStudentClubClass(){
      var self = this
      this.$vs.loading();

      let data = {
        module_id : (this.selectedStudentModule) ? this.selectedStudentModule : this.bookStudentBooking.module.id,
        package_id : this.bookStudentBooking.student.package_id,
        payment_type: "manual",
        student_id : this.bookStudentBooking.student.student_id,
        teacher_bookings_id : this.selectedTeacherBookingClubClass.id,
      }

      await this.$store.dispatch("calendarManagement/bookStudentClubClasses", data)
        .then(res => { 
          this.$vs.loading.close();
          // console.log(res)

          if(res.status == 201){
            this.$vs.notify({
              title: "Success.",
              text: "Class created successfully.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success"
            });

            this.activePromptAddStudentBooking = false;
            this.activePromptEditEvent = false;
          }
          else if(res.status == 200){
            this.$vs.notify({
              time:4000,
              title:'',
              text: (res.data.error.message) ? res.data.error.message : 'Error in booking.',
              color:'danger',
              iconPack: 'feather',
              icon:'icon-alert-circle'
            });
          }
        })
        .catch(err => { 
          this.$vs.loading.close();
          // console.log(err)
        })

      await this.$store.dispatch("calendarManagement/fetchClubClasses")
      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
      this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
    },
    FilterData() {
      var calendarEvents = this.$store.state.calendarManagement.clubClasses

      if(this.filterType == "all"){
        this.simpleCalendarEvents = calendarEvents
      }
      else if(this.filterType == "teacher"){
        let teacherId = this.filterTypeTeacher.id
        this.simpleCalendarEvents = calendarEvents.filter(obj => { return obj.teacher_id == teacherId})
      }
      else if(this.filterType == "class"){
        let classId = this.filterTypeClass.id
        this.simpleCalendarEvents = calendarEvents.filter(obj => { return obj.module_id == classId})
      }
      else if(this.filterType == "location"){
        let location = this.filterTypeLocation
        this.simpleCalendarEvents = calendarEvents.filter(obj => { return obj.class_location == location})
      }

      this.activePromptFilterEvent = false
    },
    validateAddCalendarForm() {
      this.$validator.validateAll('addCalendarForm').then(result => {
        if (result) this.createNewClubCalenderConform()
        else console.log(this.errors)
      })
    },
    validateAddLocationForm() {
      this.$validator.validateAll('addLocationForm').then(result => {
        if (result) this.createLocation()
        else console.log(this.errors)
      })
    },
    async createLocation(){
      var self = this
      this.$vs.loading({
        container: '#createLocationLoadingDiv',
        scale: 0.6
      })

      await this.$store.dispatch("calendarManagement/createLocation", { location : this.create_location })
        .then(res => { 
          this.$vs.loading.close('#createLocationLoadingDiv > .con-vs-loading')

          this.$vs.notify({
            title: "Success.",
            text: "Location added successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.create_location = null
          this.activePromptOpenLocation = false
        })
        .catch(err => { 
          this.$vs.loading.close('#createLocationLoadingDiv > .con-vs-loading')
        })
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [year, month, day].join('-');
    },
    async createNewClubCalenderConform(){
      if(this.createClubCalender.day && this.createClubCalender.day.length > 1) this.activePromptOpenConfirm = true;
      else this.createNewClubCalender();
    },
    async createNewClubCalender(){
      var self = this
      this.activePromptOpenConfirm = false;
      this.$vs.loading({
        container: '#createClubCalenderLoadingDiv',
        scale: 0.6
      })

      if(this.createClubCalender.teacherType.id == 1) var teacher_data = { teacher_id : this.createClubCalender.internalTeacher.id }
      else if(this.createClubCalender.teacherType.id == 2) var teacher_data = { teacher_id : this.createClubCalender.externalTeacher.id }
      else{
        var teacher_data = {
          teacher_name : this.createClubCalender.externalTeacher.name,
          teacher_email : this.createClubCalender.externalTeacher.email,
          teacher_phone : this.createClubCalender.externalTeacher.phone,
        }
      }

      let data = {
        day : this.createClubCalender.day,
        // repeat_for : this.createClubCalender.repeat_for,
        class_location : this.createClubCalender.class_location.label,
        module_id : this.createClubCalender.clubModules.id,
        number_of_students : this.createClubCalender.number_of_students,
        time_from : this.createClubCalender.time_from.id,
        date_from : this.formatDate(this.createClubCalender.date_from),
        date_to : this.formatDate(this.createClubCalender.date_to),
        // date_from : new Date(this.createClubCalender.date_from).toISOString().slice(0, 10),
        // date_to : new Date(this.createClubCalender.date_to).toISOString().slice(0, 10),
      }

      if(this.createClubCalender.repeat_for && this.createClubCalender.repeat_for.length) data.repeat_for = this.createClubCalender.repeat_for

      await this.$store.dispatch("calendarManagement/createClubCalender", Object.assign(data, teacher_data))
        .then(res => { 
          this.$vs.loading.close('#createClubCalenderLoadingDiv > .con-vs-loading')

          this.$vs.notify({
            title: "Success.",
            text: "Class created successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.activePromptAddEvent = false
          this.createClubCalender.date_to = ""

          if(this.createClubCalender.teacherType.id == 3) this.$store.dispatch("userManagement/fetchIntenalExternalTeachers")
        })
        .catch(err => { 
          this.$vs.loading.close('#createClubCalenderLoadingDiv > .con-vs-loading')
          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
                scope: "addCalendarForm",
              });
            });
          }

          if(err.status && err.status == 500 && err.data.errors && err.data.errors.length){
            var errorMessage = "";
            var errorMessagesArray = [];
            for(var i = 0; i < err.data.errors.length; i++){
              errorMessagesArray.push(err.data.errors[i]['new']);
            }

            errorMessagesArray = errorMessagesArray.filter(function (a) {
              var key = a.day + '|' + a.time_from + '|' + a.time_to;
              if (!this[key]) {
                  this[key] = true;
                  return true;
              }
            }, Object.create(null));

            for(var i = 0; i < errorMessagesArray.length; i++){
              errorMessage = errorMessage + ""+errorMessagesArray[i]["day"]+" : "+errorMessagesArray[i]["time_from"]+" to "+errorMessagesArray[i]["time_to"]+"<br>"
            }

            this.$vs.notify({
              title: 'You already have some time slots within flowing days',
              text: errorMessage,
              color: 'danger',
              fixed: true,
              click: () => {
                  // Secondary function
                  // this.$vs.notify({
                  //     title: 'Secondary function',
                  //     text: 'Executed the function when clicking',
                  //     color: 'success',
                  //     iconPack: 'feather',
                  //     icon: 'icon-check'
                  // })
              },
            })
          }
        })

      await this.$store.dispatch("calendarManagement/fetchClubClasses")
      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
      this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
    },
    validateEditCalendarForm() {
      this.$validator.validateAll('editCalendarForm').then(result => {
        if (result) this.editSingleClubCalenderConform()
        else console.log(this.errors)
      })
    },
    async editSingleClubCalenderConform(){
      if(this.editClubCalender.day && this.editClubCalender.day.length > 1) this.activePromptOpenConfirmEdit = true;
      else this.editSingleClubCalender();
    },
    async editSingleClubCalender() {
      var self = this
      this.activePromptOpenConfirmEdit = false;
      this.$vs.loading({
        container: '#editClubCalenderLoadingDiv',
        scale: 0.6
      })

      if(this.editClubCalender.teacherType.id == 1) var teacher_data = { teacher_id : this.editClubCalender.internalTeacher.id }
      else if(this.editClubCalender.teacherType.id == 2) var teacher_data = { teacher_id : this.editClubCalender.externalTeacher.id }
      else{
        var teacher_data = {
          teacher_name : this.editClubCalender.externalTeacher.name,
          teacher_email : this.editClubCalender.externalTeacher.email,
          teacher_phone : this.editClubCalender.externalTeacher.phone,
        }
      }

      let data = {
        class_location : this.editClubCalender.class_location.label,
        module_id : this.editClubCalender.clubModules.id,
        number_of_students : this.editClubCalender.number_of_students,
        time_from : this.editClubCalender.time_from.id,

        date_from : this.formatDate(this.editClubCalender.date_from),
        date_to : this.formatDate(this.editClubCalender.date_to),
        
        // date_from : new Date(this.editClubCalender.date_from).toISOString().slice(0, 10),
        // date_to : new Date(this.editClubCalender.date_to).toISOString().slice(0, 10),
        // day : [this.editClubCalenderData.day],
        // repeat_for : this.editClubCalender.repeat_for,
        day : this.editClubCalender.day,
        club_calendar_id : this.editClubCalenderData.id,
      }

      if(this.editClubCalender.repeat_for && this.editClubCalender.repeat_for.length) data.repeat_for = this.editClubCalender.repeat_for

      await this.$store.dispatch("calendarManagement/updateClubCalender", Object.assign(data, teacher_data))
        .then(res => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
          this.activePromptEditEvent = false;
          this.$vs.notify({
            title: "Success.",
            text: "Class updated successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          // this.$store.dispatch("calendarManagement/fetchClubClasses")
        })
        .catch(err => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                scope: "editCalendarForm",
                msg: err.data[key][0],
              });
            });
          }

          if(err.status && err.status == 500 && err.data.errors && err.data.errors.length){
            var errorMessage = "";
            var errorMessagesArray = [];
            for(var i = 0; i < err.data.errors.length; i++){
              errorMessagesArray.push(err.data.errors[i]['new']);
            }

            errorMessagesArray = errorMessagesArray.filter(function (a) {
              var key = a.day + '|' + a.time_from + '|' + a.time_to;
              if (!this[key]) {
                  this[key] = true;
                  return true;
              }
            }, Object.create(null));

            for(var i = 0; i < errorMessagesArray.length; i++){
              errorMessage = errorMessage + ""+errorMessagesArray[i]["day"]+" : "+errorMessagesArray[i]["time_from"]+" to "+errorMessagesArray[i]["time_to"]+"<br>"
            }

            this.$vs.notify({
              title: 'You already have some time slots within flowing days',
              text: errorMessage,
              color: 'danger',
              fixed: true,
              click: () => {
                  // Secondary function
                  // this.$vs.notify({
                  //     title: 'Secondary function',
                  //     text: 'Executed the function when clicking',
                  //     color: 'success',
                  //     iconPack: 'feather',
                  //     icon: 'icon-check'
                  // })
              },
            })
          }
        })

      await this.$store.dispatch("calendarManagement/fetchClubClasses")
        .then(res => { 
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 
          this.simpleCalendarEvents = [];
        })

      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
        .then(res => { 
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
          
        })
        .catch(err => { 

        })
    },
    async cancelSingleClubCalender() {
      var self = this
      this.$vs.loading({
        container: '#editClubCalenderLoadingDiv',
        scale: 0.6
      })

      await this.$store.dispatch("calendarManagement/cancelClubCalender", { club_calendar_id : this.editClubCalenderData.id})
        .then(res => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
          this.activePromptEditEvent = false;
          this.$vs.notify({
            title: "Success.",
            text: "Class cancelled successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => { 
          this.$vs.loading.close('#editClubCalenderLoadingDiv > .con-vs-loading')
        })

      await this.$store.dispatch("calendarManagement/fetchClubClasses")
        .then(res => { 
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 
          this.simpleCalendarEvents = [];
        })

      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
        .then(res => { 
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 

        })
    },
    addEvent() {
        const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
        obj.classes = "event-" + this.labelColor(this.labelLocal)
        this.$store.dispatch('calendar/addEvent', obj);
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
    clearFields() {
        this.title = this.endDate = this.url = "";
        this.id= 0;
        this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
        this.disabledFrom = false;
        this.addNewEventDialog(date);
    },
    addNewEventDialog(date) {
        this.clearFields();
        this.startDate = date;
        this.createClubCalender.date_from = date;
        this.endDate = date;
        this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
      let currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      if(date > currentDate){
        this.disabledFrom = true;
        this.addNewEventDialog(date);
      }
    },
    async cancelTeachersSlot(data) {
      // this.$vs.loading({
      //   container: '#calendarLoadingDiv',
      //   scale: 0.6
      // })
      
      await this.$store.dispatch("calendarManagement/cancelTeachersSlot", data)
      .then(res => { 
        this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')

        this.$vs.notify({
          title: "Success.",
          text: "Class cancelled successfully.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        });
      })
      .catch(err => { 
        this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
      })

      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
      this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
    },
    openEditEvent(event) {
      this.studentBooking = [];
      this.teacherClubBookings = [];
      this.teacherClassStudentBookings = [];

      if(event.originalEvent.calendar_type && event.originalEvent.calendar_type == "teacher"){
        if(event.originalEvent.view_calendar_type && event.originalEvent.view_calendar_type == "teacher_class") this.addStudentBooking(event.originalEvent);
        else{
          // let data = { teacher_booking_id : event.originalEvent.id }
          // const e = this.$store.getters['calendarManagement/getEvent'](event.id)
          // if(e.student_bookings && e.student_bookings.length){
          //   for(var j = 0; j < e.student_bookings.length; j++){
          //     this.studentBooking.push(e.student_bookings[j])
          //   }
          // }
          
          this.teacherClassStudentBookings.push(event.originalEvent)
          this.activePromptEditTeacherEvent = true;
        }
      }
      else{
        const e = this.$store.getters['calendarManagement/getEvent'](event.id)
        let clubModule = this.clubModulesData.filter(obj => { return obj.id == e.module_id})
        let timeFrom = this.timesArrayData.filter(obj => { return obj.id == e.time_from.slice(0, -3)})

        if(e.teacher_type == "Internal"){
          this.editClubCalender.teacherType = {id: 1, label: 'Internal teacher'}
          let internalTeacher = this.internalTachersData.filter(obj => { return obj.id == e.teacher_id}) 
          this.editClubCalender.internalTeacher = (internalTeacher.length) ? internalTeacher[0] : null
        } 
        else if(e.teacher_type == "External"){
          this.editClubCalender.teacherType = {id: 2, label: 'External teacher'}
          let externalTeacher = this.externalTachersData.filter(obj => { return obj.id == e.teacher_id}) 
          this.editClubCalender.externalTeacher = (externalTeacher.length) ? externalTeacher[0] : null
        }
        else{
          this.editClubCalender.teacherType = {id: 3, label: 'Add new External teacher '}
        } 

        this.studentBooking = [];
        this.teacherClubBookings = [];
        this.editClubCalender.clubModules = (clubModule.length) ? clubModule[0] : null
        this.editClubCalender.time_from = (timeFrom.length) ? timeFrom[0] : null
        this.editClubCalender.number_of_students = e.number_of_students
        this.editClubCalender.class_location = e.class_location
        this.editClubCalender.day = [e.day]
        this.editClubCalender.date_from = e.date_from
        this.editClubCalender.date_to = e.date_to
        this.editClubCalender.day = e.days_array
        this.editClubCalenderData = e;


        if(this.editClubCalender.clubModules && this.editClubCalender.clubModules.id){
          let modulesArray = this.$store.state.moduleManagement.modules
          let findModule = modulesArray.find(o => o.id === this.editClubCalender.clubModules.id);

          if(findModule && this.editClubCalender.time_from){
            this.editClubCalender.time_to = this.addMinutes(this.editClubCalender.time_from.id+":00", findModule.hours)+" ("+findModule.hours+" Min)"
          }
        }

        if(e.teacher_booking && e.teacher_booking.length){
          for(var i = 0; i < e.teacher_booking.length; i++){
            if(e.teacher_booking[i].student_bookings && e.teacher_booking[i].student_bookings.length){
              for(var j = 0; j < e.teacher_booking[i].student_bookings.length; j++){
                if(e.teacher_booking[i].student_bookings[j].attendance == null || e.teacher_booking[i].student_bookings[j].attendance == "Cancelled"){
                  this.studentBooking.push(e.teacher_booking[i].student_bookings[j])
                }
              }
            }
            else this.teacherClubBookings.push(e.teacher_booking[i])
          }
        }
        
        this.activePromptEditEvent = true;
      }
    },
    editEvent() {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeEvent', this.id)
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged(event, date) {
      this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    },
    async refreshData() {
      this.$vs.loading({
        container: '#calendarLoadingDiv',
        scale: 0.6
      })

      await this.$store.dispatch("calendarManagement/fetchClubClasses")
        .then(res => { 
          this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 
          this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
          this.simpleCalendarEvents = [];
        })

      await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
        .then(res => { 
          this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
          this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        })
        .catch(err => { 
          this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
          this.simpleCalendarEvents = [];
        })
    }
  },
  async created() {
    this.$store.registerModule('calendar', moduleCalendar)
    this.$store.dispatch("calendar/fetchEvents")
    this.$store.dispatch("calendar/fetchEventLabels")

    // Register Module UserManagement Module
    if(!moduleCalendarManagement.isRegistered) {
      this.$store.registerModule('calendarManagement', moduleCalendarManagement)
      moduleCalendarManagement.isRegistered = true
    }

    // Register Module UserManagement Module
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    if(!moduleModuleManagement.isRegistered) {
        this.$store.registerModule('moduleManagement', moduleModuleManagement)
        moduleModuleManagement.isRegistered = true
    }

    await this.$store.dispatch("userManagement/fetchTeachers")
    await this.$store.dispatch("userManagement/fetchIntenalExternalTeachers")
    // await this.$store.dispatch("calendarManagement/fetchClubClasses")
    await this.$store.dispatch("calendarManagement/fetchClubModules")
    await this.$store.dispatch("calendarManagement/fetchClubLocations")

    await this.$store.dispatch("moduleManagement/getAllModules")
    // this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
  },
  async mounted() {
    this.$vs.loading({
      container: '#calendarLoadingDiv',
      scale: 0.6
    })


    await this.$store.dispatch("calendarManagement/fetchClubClasses")
      .then(res => { 
        this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
        this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        
      })
      .catch(err => { 
        this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
      })

    await this.$store.dispatch("calendarManagement/fetchTeachersClasses")
      .then(res => { 
        this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
        this.simpleCalendarEvents = this.$store.state.calendarManagement.clubClasses
        
      })
      .catch(err => { 
        this.$vs.loading.close('#calendarLoadingDiv > .con-vs-loading')
      })
  },
  beforeDestroy() {
    this.$store.unregisterModule('calendar')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>

<style lang="css">
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

#createClubCalenderLoadingDiv{
  height: 100%;
  overflow: auto;
}

#editClubCalenderLoadingDiv{
  height: 100%;
  overflow: auto;
}

/*.cv-week{
  height : 300px !important;
}

.cv-day{
  height : 300px !important;
}*/

.cv-day-number{
  height : 25px !important;
}

.clubCalendarCls {
  height: 1000px !important;
}

.calEventStudentBooking{
  background-color: #860C5A !important;
}
</style>
